import { filterUserNavigationItems, userNavigationItems } from '@/config/userNavigation'
import { getFirstAccessibleAdminRoute } from '@/config/adminNavigation'
import type { PermissionedRouteCandidate } from '@/config/businessRoutePermissions'
import type { PermissionedMenuItem } from '@/types/permission'
import { canAccessPermissionRequirement } from '@/utils/permission'

const FORBIDDEN_ROUTE = '/403'

export function getDefaultRoute(permissions: string[], isAdmin = false): string {
  const firstVisibleRoute = filterUserNavigationItems(userNavigationItems, permissions, isAdmin)
    .map(item => getDefaultRouteForMenuItem(item, permissions, isAdmin))
    .find(Boolean)

  return firstVisibleRoute || getFirstAccessibleAdminRoute(permissions, isAdmin) || FORBIDDEN_ROUTE
}

export function getDefaultRouteForMenuItem(
  item: PermissionedMenuItem,
  permissions: string[],
  isAdmin = false
): string | undefined {
  if (item.defaultRouteCandidates?.length) {
    return getFirstAccessibleRoute(item.defaultRouteCandidates, permissions, isAdmin)
  }

  return item.route
}

export function getFirstAccessibleRoute(
  candidates: PermissionedRouteCandidate[],
  permissions: string[],
  isAdmin = false
): string | undefined {
  return candidates.find(candidate => (
    canAccessPermissionRequirement(candidate.permission, permissions, isAdmin)
  ))?.route
}

export function getFirstAccessibleRouteFromStorage(
  candidates: PermissionedRouteCandidate[],
  fallback = FORBIDDEN_ROUTE
): string {
  return getFirstAccessibleRoute(candidates, readPermissionsFromStorage()) || fallback
}

export function getDefaultRouteFromStorage(): string {
  const permissions = readPermissionsFromStorage()

  return getDefaultRoute(permissions)
}

function readPermissionsFromStorage(): string[] {
  try {
    const raw = localStorage.getItem('permissions')
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}
